import {EllipsisOutlined} from "@ant-design/icons";
import DropdownMenu from "../../../../components/DropdownMenu";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {MemberInfoListActions} from "../../PreviewKeyCondition/model";
import {ExclusionConfirmationModal} from "./ExclusionConfirmationModal";
import {useGetIndividualInclusionMemberDetails} from "../common/hooks/GetIndividualInclusionMemberDetails";

function MemberAction({user, userGroupName}) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const excludedMembersList =
    useSelector((rootState) => rootState.membersMatchingConditionList.excludedMembers);
  const isIndividualInclusion = Boolean(useGetIndividualInclusionMemberDetails(userGroupName, user.key));
  const dispatch = useDispatch();

  const shouldDisableExcludeButton = () => isIndividualInclusion

  const onConfirmation = (excludeReason) => {
    dispatch(MemberInfoListActions.addExcludedMembers(
      [{
        userId: user.key,
        reason: excludeReason
      }]
    ))
    setIsModalVisible(false)
  }

  const getActionButtons = () => {
    const isUserAlreadyExcluded = excludedMembersList.find((excludedMember) => excludedMember.userId === user.key)
    return isUserAlreadyExcluded
      ? [{
        label: "Include",
        onClick: () => dispatch(MemberInfoListActions.removeExcludedMember(user.key))
      }]
      : [{
        label: "Exclude",
        onClick: () => setIsModalVisible(true),
        disabled: shouldDisableExcludeButton()
      }]
  }

  return (
    <div className="MemberActions">
      <DropdownMenu
        actions={getActionButtons()}
      >
        <EllipsisOutlined role="button" style={{color: "#000000", fontSize: "22px", cursor: "pointer"}}/>
      </DropdownMenu>
      <ExclusionConfirmationModal
        users={[user]}
        isVisible={isModalVisible}
        setModalVisibility={setIsModalVisible}
        onConfirm={onConfirmation}
      />
    </div>
  );
}

export default MemberAction;
